import React from 'react';

type FallbackBGProps = {
  startStopColor: string;
  middleStopColor: string;
  endStopColor: string;
};

const FallbackBG: React.FC<FallbackBGProps> = ({
  startStopColor,
  middleStopColor,
  endStopColor,
}) => (
  <svg viewBox='0 0 1440 900' preserveAspectRatio='none' className='svg-background' opacity='0.9'>
    <defs>
      <linearGradient
        id='linear-gradient'
        x1='0.772'
        y1='1.03'
        x2='0.571'
        y2='0.403'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stopColor={startStopColor} />
        <stop offset='0.418' stopColor={middleStopColor} />
        <stop offset='1' stopColor={endStopColor} stopOpacity='0' />
      </linearGradient>
    </defs>
    <g id='bg_404'>
      <rect width='1440' height='900' fill='url(#linear-gradient)' />
    </g>
  </svg>
);

export { FallbackBG };
